function pick(obj, list) {
  const nextObj = {};
  for (const key in obj) obj.hasOwnProperty(key) && list[key] === !0 && (nextObj[key] = obj[key]);
  return nextObj;
}
export { pick as default };
//# sourceMappingURL=index.mjs.map
